import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { BeneficiarySoaEmailDetail } from '../models/soa-view-email-model'
import { SOAFormReturnAgentGateWay } from '../gateways/soa-form-return-agent-gateways'
import { HttpClient } from '@angular/common/http'
@Injectable()
export class NetworkViewSOAFormReturnAgentGateway extends SOAFormReturnAgentGateWay {
    constructor(private http: HttpClient) {
        super()
    }

    // TODO once methos in controller are defined , please call from here in order to return data from backend

    returnToAgent(returnToAgentSOADetail: BeneficiarySoaEmailDetail): Observable<boolean> {
        console.log('returntoagent way')
        return this.http.post<boolean>('../api/UpdateBeneficiarySOAStatus', JSON.stringify(returnToAgentSOADetail))
    }

    GetSOADetailsOnUniqueLink(uniqueLink: string): Observable<BeneficiarySoaEmailDetail> {
        let URL = '../api/GetSOADetailsOnUniqueLink/' + uniqueLink
        console.log('unique link way')

        return this.http.get<BeneficiarySoaEmailDetail>(URL)
    }
}
